import {
  BoxSpg,
  CONTENT_MANAGEMENT_ID,
  HtmlParseText,
  CircularTextLoader,
  THUNK_STATUS,
} from "@duosoftbg/nacid-components";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { useEffect } from "react";
import { fetchServiceDescription } from "../../../../../store/redux/slice/AppData/servicesDescriptions";
import { useTranslation } from "react-i18next";
import { Alert } from "@mui/material";

const ARUniEntryRequestDescription = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const descriptionCode = CONTENT_MANAGEMENT_ID.SD_AR_UNI_ENTRY_REQUEST;

  const servicesDescriptions = useAppSelector((state) => {
    return state.AppData.servicesDescriptions;
  });

  useEffect(() => {
    dispatch(fetchServiceDescription(descriptionCode));
  }, [descriptionCode, dispatch]);

  if (!servicesDescriptions[descriptionCode]?.status) {
    return (
      <BoxSpg>
        <CircularTextLoader />
      </BoxSpg>
    );
  }
  if (servicesDescriptions[descriptionCode]?.status === THUNK_STATUS.REJECTED) {
    return (
      <BoxSpg>
        <Alert severity={"error"}>{t("m.generic.error.service.fail")}</Alert>
      </BoxSpg>
    );
  }
  return (
    <BoxSpg>
      {servicesDescriptions[descriptionCode].status === THUNK_STATUS.FULFILLED ? (
        <HtmlParseText text={servicesDescriptions[descriptionCode].content} styleArray={{ pointerEvents: "none" }} />
      ) : (
        <CircularTextLoader />
      )}
    </BoxSpg>
  );
};
export default ARUniEntryRequestDescription;
